export enum DEVICE_TYPE {
  KIOSK = "kiosk",
  POS = "pos"
};
